import { all } from 'redux-saga/effects'
import { _updateProfileStatus } from './saga';

export default function* rootSaga() {
    yield all([_updateProfileStatus]);

}